import { Component, Input } from '@angular/core';

@Component({
  selector: 'jnt-week-metric',
  template: ''
})
export class WeekMetricComponent {

  @Input()
  title: string;

}
